/**
 * Cap on any comment written to a violation thread. The thread has no
 * pagination and every drawer open fetches every comment on the violation, so
 * an unbounded body is a self-inflicted payload problem — cap it well above any
 * legitimate use.
 *
 * Shared rather than mirrored: the API rejects a longer body and Oak's inputs
 * stop the user at the same number, so the two must move together.
 */
export const MAX_COMMENT_LENGTH = 10_000;
